import axios from 'axios';
import QS from 'qs';
import Store from '../vuex/store';
import Config from '../utils/config';
import SR from '../utils/sign';
import { Notification } from 'element-ui';
const baseUrl = '/proxy'
const jimUrl = '/jim'

// json加密请求
const imFetch = (method, url, data) => {
  return axios({
    method: method,
    url: jimUrl + url,
    headers: {
      'token': Store.getters.imToken,
      'clientId': Config.$CLIENT_ID
    },
    data: SR(data)
  }).then(res => {
    if (res.data.code === '40101') {
      Notification({
        type: 'warning',
        title: '登录失效',
        message: res.data.msg
      });
      Store.commit('logout');
    }
    return res.data
  });
}

// json格式的请求
const fetch = (method, url, params) => {
  return axios({
    method: method,
    url: baseUrl + url,
    data: params
  }).then(res => res.data);
};
// 通用公用方法
const req = (method, url, params) => {
  const reqParams = {
    method: method,
    url: baseUrl + url,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  };
  if (method === 'get' || method === 'delete') {
    reqParams['params'] = params;
  }
  if (method === 'post' || method === 'put') {
    reqParams['data'] = QS.stringify(params);
  }
  return axios(reqParams)
    .then(res => res.data)
    .catch(err => {
      console.error('请求错误：', err);
    });
};

export {
  fetch,
  req,
  imFetch
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js